/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DocsTextIcon20Solid = forwardRef('DocsTextIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.004 4.748a2.25 2.25 0 0 0 2.25 2.25H15V14a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V4a3 3 0 0 1 3-3h3.004v3.748ZM6 12.5A.75.75 0 0 0 6 14h2.75a.75.75 0 0 0 0-1.5H6Zm-.75-2.25A.75.75 0 0 1 6 9.5h6a.75.75 0 1 1 0 1.5H6a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "m10.504 1.139 4.36 4.359h-3.61a.75.75 0 0 1-.75-.75V1.139Z" }),
        React.createElement("path", { d: "M17.563 7.5a.75.75 0 1 0-1.5 0v6.781a3.75 3.75 0 0 1-3.75 3.75H7.5a.75.75 0 0 0 0 1.5h4.813c2.899 0 5.25-2.35 5.25-5.25V7.5Z" })));
});
